'use client';
import React from 'react';

interface PropertyCard {
  title: string;
  image: string;
  alt: string;
  href: string;
}

const propertyCards: PropertyCard[] = [
{
  title: 'Affordable',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d0ea16fd-1766933751517.png",
  alt: 'Affordable housing community with well-maintained apartment buildings and green landscaping',
  href: '/portfolio'
},
{
  title: 'Student Housing',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_11775f12a-1776834607106.png",
  alt: 'Senior living community with comfortable amenities and accessible design for older adults',
  href: '/portfolio'
},
{
  title: 'Market-Rate',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_120113da7-1771888846062.png",
  alt: 'Market-rate apartment community with modern architecture and premium finishes',
  href: '/portfolio'
},
{
  title: 'Attainable',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1589c2f13-1779936774877.png",
  alt: 'Attainable housing development with innovative design making homeownership accessible',
  href: '/portfolio'
},
{
  title: 'Mixed-Use',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_101aa9c86-1768021204942.png",
  alt: 'Mixed-use development combining residential units with retail and community spaces',
  href: '/portfolio'
}];


export default function LinkCardsSection() {
  return (
    <section
      id="portfolio"
      className="relative bg-white py-12 md:py-16 lg:py-20">

      {/* Background pattern */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url('https://tmo.com/wp-content/uploads/2024/07/pattern-bg-01.png')`,
          backgroundRepeat: 'repeat',
          opacity: 0.4,
          pointerEvents: 'none'
        }} />


      <div className="relative" style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
        {/* Section Header */}
        <div className="mb-8 md:mb-10">
          <h2
            style={{
              fontSize: 'clamp(24px, 3vw, 36px)',
              fontWeight: 400,
              color: '#003c82',
              margin: 0,
              fontFamily: 'Montserrat, sans-serif'
            }}>

            A Place to Call Home
          </h2>
        </div>

        {/* Cards Grid — 1 col mobile, 2 col sm, 3 col md, 5 col xl */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
          {propertyCards.map((card) =>
          <a
            key={card.title}
            href={card.href}
            style={{ textDecoration: 'none', display: 'block' }}>

              <div
              className="link-card"
              style={{
                position: 'relative',
                overflow: 'hidden',
                cursor: 'pointer'
              }}>

                {/* Image */}
                <div style={{ overflow: 'hidden' }}>
                  <img
                  src={card.image}
                  alt={card.alt}
                  style={{
                    width: '100%',
                    height: '220px',
                    objectFit: 'cover',
                    display: 'block',
                    transition: 'transform 0.4s ease'
                  }}
                  onMouseEnter={(e) => {(e.currentTarget as HTMLImageElement).style.transform = 'scale(1.05)';}}
                  onMouseLeave={(e) => {(e.currentTarget as HTMLImageElement).style.transform = 'scale(1)';}} />

                </div>

                {/* Overlay */}
                <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to top, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 60%)'
                }} />


                {/* Content */}
                <div
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  padding: '20px',
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between'
                }}>

                  <h3
                  style={{
                    color: '#ffffff',
                    fontSize: '18px',
                    fontWeight: 500,
                    margin: 0,
                    fontFamily: 'Montserrat, sans-serif'
                  }}>

                    {card.title}
                  </h3>
                  <svg width="32" height="16" viewBox="0 0 39 32" fill="none" style={{ color: '#ffffff', flexShrink: 0 }}>
                    <path d="M22.721 1.228l15.015 15.015-15.015 15.015" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M37.791 16.242h-37.606" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
            </a>
          )}
        </div>
      </div>
    </section>);

}